"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("jquery-ui/dist/jquery-ui");
require("jquery-ui/dist/themes/base/jquery-ui.css");
require("jquery-ui/dist/themes/base/theme.css");
require("jquery.cookie");
require("spectrum-colorpicker");
require("spectrum-colorpicker/spectrum.css");
const toastr_1 = __importDefault(require("toastr"));
require("toastr/build/toastr.css");
require("font-awesome/css/font-awesome.css");
// Initialisation des projections
require("./openlayers/projections");
// Configuration de toastr
toastr_1.default.options = {
    "closeButton": true,
    "debug": false,
    "positionClass": "toast-bottom-right",
    "onclick": undefined,
    "showDuration": 300,
    "hideDuration": 1000,
    "timeOut": 15000,
    "extendedTimeOut": 5000,
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};
window.JGN = {};
